import { useState } from "react";
import Header from "./common/Header";
import Footer from "./common/Footer";
import Sidebar from "./common/Sidebar";
// import EnhancedTable from "./common/EnhancedTable";
//import Approval from "./Approval";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import http from "../api/server";
import Iframe from "react-iframe";
import { GET_ANONYMOUS_INSPECTION_DATA,
  UPDATE_PROPERTY_USER_MAPPING_STATUS, } from "../api/apiPath";
import { Statuses } from "../components/common/constant";
import { useSelector } from "react-redux";
import Toaster from "./common/Toaster";
import DataGridTable from "./common/DataGridTable";


const PropertyViewDetails = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [complianceData, setComplianceData] = useState(null);
  const [showSubmitLoader, setShowSubmitLoader] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const { propertyMasterId } = useParams();
  //const location = useLocation();
  //const { propertyInfo, userRole } = location.state || {};
  const { userObj } = useSelector((state) => state.user);
  const [showConfimBox, setShowConfimBox] = useState(false);
  const [propertyUserRoleMappingId, setPropertyUserRoleMappingId] = useState(null);
  const [inspectorInspectionStatus, setInspectorInspectionStatus] = useState(null);
  const [propertyInfo, setPropertyInfo] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  // const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  useEffect(() => {
    setUserRole(null);
    setPropertyInfo(null);
    setComplianceData(null);
    setPropertyUserRoleMappingId(null);
    setInspectorInspectionStatus(null)
    const fetchData = async () => {
      try {
        //getPropertyUserMapping();
        // const responseClient = await http.get(
        //   GET_CLINET_ID_API + "/" + userObj?.userId
        // );
        //setUserRole(responseClient?.data?.roleId);
        // const response = await http.get(
        //   `${GET_PROPERTY_COMPLIANCE_SUMMARY}?propertyMasterId=${propertyMasterId}`
        // );
        // setComplianceData(response.data);
        // const response1 = await http.get(
        //   GET_PROPERTY_INFO_WITH_MASTER + propertyMasterId
        // );
        // if (!response1.status) {
        //   throw new Error(`HTTP error! status: ${response1?.status}`);
        // }
        // setPropertyInfo(response1?.data?.inspectionPropertyInfo);

        const responseAnonymousData = await http.get(
          GET_ANONYMOUS_INSPECTION_DATA + userObj?.userEmail
        )
        if (!responseAnonymousData.status) {
          throw new Error(`HTTP error! status: ${responseAnonymousData?.status}`);
        }
        const anonymousData = await responseAnonymousData?.data;
        console.log("data", anonymousData);
        
        let TotalDoors = 0; let totalCompliantCount = 0; let totalnonCompliantCount = 0; 
        let totalcriticalNonComplianceCount = 0;
        let allDoorComplianceDetails = [];
        if(anonymousData.length > 0){
          anonymousData.forEach((ppty) => {
            TotalDoors += ppty.totalDoors;
            totalCompliantCount += ppty.compliantCount;
            totalnonCompliantCount += ppty.nonCompliantCount;
            totalcriticalNonComplianceCount += ppty.criticalNonComplianceCount;
            let tempDoorDetails = ppty.doorComplianceDetails;
            tempDoorDetails.map((door) => {
              door.propertyName = ppty.propertyName
            })
            allDoorComplianceDetails = [...allDoorComplianceDetails, ...tempDoorDetails]
          })
        }
        let compRate = isNaN((totalCompliantCount/TotalDoors)*100) ? 0 : (totalCompliantCount/TotalDoors)*100;

        setComplianceData({
          totalDoors: TotalDoors,
          criticalNonComplianceCount: totalcriticalNonComplianceCount,
          compliantCount: totalCompliantCount,
          nonCompliantCount: totalnonCompliantCount,
          complianceRate: compRate,
          doorComplianceDetails: allDoorComplianceDetails
        })
       

      } catch (error) {
      throw new Error(`HTTP error! status: ${error}`);

      } finally {
        setLoading(false);
      }
    };

    fetchData();

  }, []);
  const gotoDashBoard = () => {
    navigate("/new-survey");
  };

  // const getPropertyUserMapping = async () => {
  //   const propInfoResp = await http.get(
  //     GET_PROPERTY_USER_MAPPING + propertyMasterId
  //   );
  //   if (!propInfoResp.status) {
  //     throw new Error(`HTTP error! status: ${propInfoResp?.status}`);
  //   }
  //   var status = propInfoResp?.data?.filter(d => d.userId == userObj.userId)[0]?.status;
  //   if (status) {
  //     setInspectorInspectionStatus(status)
  //   }
  //   var propertyUserRoleMappingId = propInfoResp?.data?.filter(d => d.userId == userObj.userId)[0]?.propertyUserRoleMappingId;
  //   setPropertyUserRoleMappingId(propertyUserRoleMappingId);
    

   
  // };

  const UpdateStatus = async () => {
    setShowSubmitLoader(true);
    const payload = {
      propertyUserRoleMappingId: propertyUserRoleMappingId,
      status: Statuses.COMPLETED,
      propertyMasterId:propertyMasterId,
      userId:userObj?.userId,
      email:userObj?.userEmail

    };
    try {
      const response = await http.put(UPDATE_PROPERTY_USER_MAPPING_STATUS + propertyUserRoleMappingId, payload);
      response.status === 200
        ? setToastData({
          toastShow: true,
          toastType: "success",
          toastString: "Survey has been submitted for approval",
        })
        : setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Error in saving data, please try again",
        });
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
      setShowConfimBox(false);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      console.error("API Error:", error);
      // Display error message to user, if needed
    }finally {
      setShowSubmitLoader(false);
    }
  };

  const handleCancel = () => {
    setShowConfimBox(false);
  };

  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };


  const criticalIssues = complianceData?.criticalNonComplianceCount;
  // const handleBack = () => {
  //   navigate("/property-form")
  // }
  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      <div className="dashboard_body_main d-flex vh-100">
        {hideSidebar && <Sidebar />}
        <Toaster
          show={toastData.toastShow}
          toastType={toastData.toastType}
          title={toastData.toastString}
          theme={"dark"}
          position="top-center"
          closeButton={() => { closeButton() }}
        />
        {loading ? (
          <div className="spinloader"></div>
        ) : (<div className="d-flex dashboard_body newSurvey flex-column py-1 w-100">
          <form className="row m-0">
            {criticalIssues >= 1 && (
              <div className="mb-3">
                <div className="d-flex align-items-center gap-2 information-icon w-auto float-end">
                  <i className="bi bi-info-circle" style={{ fontSize: "1.2rem",marginTop:"-7px" }}></i>
                  <small>
                    Some doors require attentions to maintain compliance
                  </small>
                  <span className="badge bg-warning text-dark rounded-circle">
                    {criticalIssues}
                  </span>
                </div>
              </div>
            )}
            <div className="row mb-3 ">
              <div
                className="col-sm-12 d-flex justify-content-end"
              >
                <button
                  type="button"
                  className="btn btn-primary py-2 px-4"
                  onClick={() => {gotoDashBoard()}}
                  style={{ borderRadius: "8px" }}
                >
                  <i className="fa fa-solid fa-plus me-2"></i>New Survey
                </button>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-lg-12 mb-3">
              <div className="card">
                <div className="card-body">
                  <h5 className="justifyStart">Compliance Summary</h5>

                  <div className="row text-center d-flex justify-content-between mt-0">

                    <div className="col-6 col-sm-4 col-lg-2 mb-1">
                      <h3>{complianceData?.totalDoors}</h3>
                      <p className="fw-semibold">Total Doors</p>
                    </div>

                    <div className="col-6 col-sm-4 col-lg-2 mb-1">
                      <h3 className="text-success">
                        {complianceData?.compliantCount}
                      </h3>
                      <p className="fw-semibold">Compliant</p>
                    </div>
                    <div className="col-6 col-sm-4 col-lg-2 mb-1">
                      <h3 className="text-danger">
                        {complianceData?.nonCompliantCount}
                      </h3>
                      <p className="fw-semibold">Non-Compliant</p>
                    </div>
                    <div className="col-6 col-sm-4 col-lg-2 mb-1">
                      <h3>{complianceData?.criticalNonComplianceCount}</h3>
                      <p className="fw-semibold">Critical Issues</p>
                    </div>

                    {/* <div className="col-4 col-sm-2">
                      <h3>1</h3>
                      <p className="fw-semibold">Require Attention</p>
                    </div> */}

                  </div>
                  <div className="mt-1">
                    <small className="mb-2 d-block">
                      Overall Compliance Rate : {isNaN(complianceData?.complianceRate)
                        ? complianceData?.complianceRate : Math.round(Number(complianceData?.complianceRate))}
                      %
                    </small>
                    <div className="progress completed">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: `${complianceData?.complianceRate}%` }}
                        aria-valuenow="40"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-lg-12 mb-3 ">
              <div className="card">
                <div className="card-body">
                  <h5 className="justifyStart">Door Surveys</h5>
                  
                  <div className="table-responsive">
                    {/* {complianceData?.doorComplianceDetails?.length > 0 && (
                      <EnhancedTable
                        tableData={complianceData.doorComplianceDetails}
                      />
                    )} */}
                    {complianceData?.doorComplianceDetails?.length > 0 && (
                      <DataGridTable
                        tableData={complianceData.doorComplianceDetails.sort((a, b) =>
                           new Date(b.doorInspectionDate) - new Date(a.doorInspectionDate))}
                           userRole={userRole} propertyInfo={propertyInfo}  inspectorInspectionStatus={inspectorInspectionStatus}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="card-body action_btns d-flex justify-content-end gap-3 pb-3 px-3 flex-wrap flex-sm-nowrap">
              <button
                type="button"
                className="btn btn-secondary"

                onClick={() => {
                  handleBack();
                }}
              >
                Back
              </button>
            </div> */}
          </form>
          <Footer />
        </div>)}
      </div>
      {/* {showModal && (
        <Approval data={propertyInfo} onClose={() => { setShowModal(false) }} />
      )} */}
      {showConfimBox &&
        <div className="modal-overlay">
          <div className="approval-modal-content" style={{ height: "30%" }}>
            <span className="close" onClick={handleCancel}>
              &times;
            </span>
            <h6 className="modal-header">
              Confirmation
            </h6>{" "}
            {/* Modal Header */}
            <div className="modal-body">
              <span>Once you submit for approval, you will no longer be able to modify or complete any pending door
                inspections. Please make sure all door surveys are fully completed before proceeding.</span>
              <div className="row mt-5">
                <div>
                  <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                    
                    { showSubmitLoader ? (
                      <div className="loader mt-2" style={{marginRight: "20px"}}></div>
                    ) : (
                      <>
                      <button type="button" className="btn btn-tertiary" onClick={() => { handleCancel() }}>
                      Cancel
                    </button>
                      <button type="button" className="btn btn-primary" onClick={() => { UpdateStatus() }}>
                        Submit
                      </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {showPdfModal && pdfUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 1050,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "90%",
              maxHeight: "80vh",
              backgroundColor: "#fff",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                padding: "10px 15px",
                borderBottom: "1px solid #ddd",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 className="modal-title mb-0">PDF Preview</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setShowPdfModal(false);
                  setPdfUrl(null);
                }}
              ></button>
            </div>
            <div style={{ height: "90vh", padding: 0 }}>
       
              <Iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                title="PDF Preview"
                style={{
                  border: "none",
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
                frameBorder="0"
              ></Iframe>
            </div>
          </div>
        </div>
      )}

    </>
  );
};
export default PropertyViewDetails;
